import FutureImage from '../../FutureImage';
import { namingTips } from './nameIdeasContent';

// Long-form naming guidance — SSR content depth for the generator page.
export default function NamingTips() {
  return (
    <section className="tw-py-10 tw-bg-white sm:tw-py-16 lg:tw-py-24">
      <div className="tw-max-w-4xl tw-px-4 tw-mx-auto sm:tw-px-6 lg:tw-px-8">
        <h2 className="tw-text-3xl tw-font-bold tw-leading-tight tw-text-gray-900 sm:tw-text-4xl lg:tw-text-5xl">
          How to Choose a Travel Blog Name
        </h2>
        <p className="tw-mt-4 tw-max-w-2xl tw-text-base tw-leading-relaxed tw-text-gray-600">
          A generator gets you options; these rules help you pick the one you
          won&apos;t regret two years and forty countries later.
        </p>

        <FutureImage
          src="/img/name-ideas/journal.jpg"
          alt="Compass resting on an open travel journal with a shortlist of names"
          width={1536}
          height={1024}
          sizes="(max-width: 896px) 100vw, 832px"
          className="tw-mt-8 tw-h-auto tw-w-full tw-rounded-2xl"
        />

        <div className="tw-mt-6 tw-divide-y tw-divide-gray-200">
          {namingTips.map(tip => (
            <div className="tw-py-8" key={tip.id} id={tip.id}>
              <h3 className="tw-m-0 tw-text-xl tw-font-semibold tw-text-gray-900">
                {tip.title}
              </h3>
              <p className="tw-mb-0 tw-mt-3 tw-text-base tw-leading-relaxed tw-text-gray-600">
                {tip.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
